// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Ai2-","select":"styles_select__Y7XQf"};